module.exports = require("babel-runtime/helpers/typeof");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/typeof"
// module id = 32
// module chunks = 0